import { render, staticRenderFns } from "./MenuItemCotizacion.vue?vue&type=template&id=511d1ea1&scoped=true&"
import script from "./MenuItemCotizacion.vue?vue&type=script&lang=js&"
export * from "./MenuItemCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemCotizacion.vue?vue&type=style&index=0&id=511d1ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d1ea1",
  null
  
)

export default component.exports